import ApiService from "@/common/api.service"

export const CourseReportService = {
    async getCourses(params) {
        const res = await ApiService.get(`/courses${params}`);
        return res.data
    }
}